/**
 * @description Gestion du comportement du contenu éditorial
 */

(() => {
    //VARIABLES
    const translation = {
        close: Drupal.t("Close"),
        previous: Drupal.t("Previous"),
        next: Drupal.t("Next")
    }
    const field = document.querySelector('.field-content');
    const allFigs = field.querySelectorAll('[data-src-full]');
    const figsCount = allFigs.length;
    const modalContainer = `<div id="modalZoom" class="modal" aria-hidden="true">
    <p class="modal__count">
          <span id="photo-id"></span>/<span id="photo-total">${figsCount}</span>
        </p>
        <div class="modal__content">
            <button title="${translation.close}" class="close"><i data-icon="cross"></i></button>
            <button class="prec" id="zoom-prec" data-icon="arrow" data-set-prev>${translation.previous}</button>
            <button class="next" id="zoom-next" data-icon="arrow" data-set-next>${translation.next}</button>
        </div>
    </div>`;
    const focusableElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

    // FONCTIONS
    const insertModal = () => {
        if(allFigs) {
            field.insertAdjacentHTML('beforeend', modalContainer);
        }
    }
    /**
     * 
     * @param {number} number numero de l'image
     * @param {string} source source de l'image
     * @param {string[]} tabImg tableau des sources de toutes les images
     */
    const modalContent = (number = 0, source = "", tabImg) => {
        const modal = document.querySelector('#modalZoom');
        const buttonPrec = modal.querySelector('#zoom-prec');
        const buttonNext = modal.querySelector('#zoom-next');
        let dataSetPrev = number - 1;
        let dataSetNext = number + 1;      
        let img = `<img id="img-full" class="modal__img" src="${source}" alt="" />`

        modal.setAttribute('aria-hidden', false);
        modal.querySelector('#photo-id').innerHTML = `${number}`;
        if(modal.querySelector('#img-full')) {
            modal.querySelector('.modal__content').removeChild(modal.querySelector('#img-full'));
        }
        modal.querySelector('#zoom-prec').insertAdjacentHTML('afterend', img);
        buttonPrec.setAttribute('data-set-prev', dataSetPrev);
        buttonNext.setAttribute('data-set-next', dataSetNext);
        precImage(tabImg);
        nextImage(tabImg);
        checkPosition(modal, tabImg);
        
    }

    // ajoute un index data-set à chaque figure
    const addDataSet = () => {
        if(allFigs) {
            let figsCount = 1;
            allFigs.forEach(fig => {
                fig.setAttribute('data-set', figsCount);
                figsCount ++;
            })
        }
    };
   
    /**
     * @returns {string[]} Tableau des sources des images
     */
    const createTabImg = () => {
        const tabImg = [];
        allFigs.forEach(fig => {
            tabImg.push(fig.getAttribute('data-src-full'));
        });
        return tabImg;
    }

    /**
     * Verifie la position et retire les boutons précédent et suivant en fonction
     */
    const checkPosition = (m, tabImg) => {
        const buttonPrec = m.querySelector('#zoom-prec');
        const buttonNext = m.querySelector('#zoom-next');
        let precIndex = parseInt(buttonPrec.getAttribute(['data-set-prev']));
        let nextIndex = parseInt(buttonNext.getAttribute(['data-set-next']));

        if(tabImg.length === 1) {
            buttonPrec.style.display = "none";
            buttonNext.style.display = "none";
        }

        if(precIndex === 0) {
            if(buttonNext.style.display === "none") {
                buttonNext.style.display = "block";
            }
            buttonPrec.style.display = "none";
        } else if(nextIndex > tabImg.length) {
            if(buttonPrec.style.display === "none") {
                buttonPrec.style.display = "block";
            }
            buttonNext.style.display = "none";
        } else {
            buttonPrec.style.display = "block";
            buttonNext.style.display = "block";
        }
    }

    /**
     * Comportement du bouton précédent
     */
    const precImage = (tabImg) => {
        const modal = document.getElementById('modalZoom');
        const buttonPrec = modal.querySelector('#zoom-prec');
        let precIndex = parseInt(buttonPrec.getAttribute(['data-set-prev']));

        if(buttonPrec) {
            buttonPrec.addEventListener('click', () => {
                modalContent(precIndex, tabImg.find((element, index) => element ? index === precIndex - 1 : null), tabImg);
                keyboardNavigation(modal);
            });
        }
    }

    /**
     * Comportement du bouton suivant
     */
    const nextImage = (tabImg) => {
        const modal = document.getElementById('modalZoom');
        const buttonNext = modal.querySelector('#zoom-next');
        let nextIndex = parseInt(buttonNext.getAttribute(['data-set-next']));

        if(buttonNext) {
            buttonNext.addEventListener('click', () => {
                modalContent(nextIndex, tabImg.find((element, index) => element ? index === nextIndex - 1 : null), tabImg);
                keyboardNavigation(modal);
            });
        }
    }

    /**
     * 
     * @param {Element} m la modal
     * @description Naviguer au clavier dans la modal
     */
    const keyboardNavigation = (m) => {
        const firstFocusableElement = m.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        const focusableContent = m.querySelectorAll(focusableElements);
        const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal


        document.addEventListener('keydown', function(e) {
            let isTabPressed = e.key === 'Tab';

            if (!isTabPressed) {
                return;
            }

            if (e.shiftKey) { // if shift key pressed for shift + tab combination
                if (document.activeElement === firstFocusableElement) {
                    lastFocusableElement.focus(); // add focus for the last focusable element
                    e.preventDefault();
                }
            } else { // if tab key is pressed
                if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                    firstFocusableElement.focus(); // add focus for the first focusable element
                    e.preventDefault();
                }
            }
        });

        firstFocusableElement.focus();
    }

    /**
     * 
     * @param {*} m la modal
     * @description ferme la modal
     */
    const closeModal = (m) => {
        const closeButton = m.querySelector('button.close');

        closeButton.addEventListener('click', () => {
            m.setAttribute('data-active', false);
            m.setAttribute('aria-hidden', true);
        });
    }

    /**
     * 
     * @param {*} tabImg tableau des sources des images
     * @description Ouverture de la modal
     */
    const zoomImg = (tabImg) => {
        let imageSrc = "";
        let imageIndex = 0;
        const theModal = document.getElementById('modalZoom');

        allFigs.forEach(fig => {
            const btn = fig.querySelector('button.open-figure-modal') ;

            btn.addEventListener('click', () => {
                const figDataSet = parseInt(fig.getAttribute('data-set'));

                theModal.setAttribute('data-active', true);
                imageSrc = tabImg.find((element, index) => element ? index + 1 === figDataSet : 'truc');
                imageIndex = tabImg.findIndex((element, index) => element ? index + 1 === figDataSet : 'truc');
                modalContent(imageIndex + 1, imageSrc, tabImg);
                keyboardNavigation(theModal);
            })
        });
        closeModal(theModal);
    }
  
    // GO 🚀
    const init = () => {
        const tabImg = createTabImg();
        insertModal()
        addDataSet();
        zoomImg(tabImg);
    };
  
    init();
})();